import React, { useState } from 'react';
import { Input, PhoneInput, Button } from './UI';

export default function MFYForm({ user, onSave, onClose }) {
  const isEdit = !!user;
  const [form, setForm] = useState({
    first_name: user?.first_name || '',
    last_name: user?.last_name || '',
    username: user?.username || '',
    password: '',
    password_confirm: '',
    phone: user?.phone || '',
    mfy_nomi: user?.mfy_nomi || '',
    lavozim: user?.lavozim || '',
  });
  const [error, setError] = useState('');

  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const handleSave = () => {
    if (!form.first_name || !form.last_name || !form.username) {
      setError("Ism, familiya va login to'ldirilishi shart");
      return;
    }
    if (!isEdit && !form.password) {
      setError("Parol kiritilishi shart");
      return;
    }
    if (form.password && form.password !== form.password_confirm) {
      setError("Parollar bir xil emas");
      return;
    }
    if (form.password && form.password.length < 6) {
      setError("Parol kamida 6 ta belgidan iborat bo'lishi kerak");
      return;
    }
    if (!form.mfy_nomi) {
      setError("MFY nomini kiriting");
      return;
    }
    setError('');
    const data = { ...form, role: 'mfy' };
    delete data.password_confirm;
    if (isEdit && !data.password) delete data.password;
    onSave(data);
  };

  return (
    <div>
      {error && <div style={{ padding: '10px 16px', borderRadius: 10, background: '#fee2e2', color: 'var(--red)', fontSize: 13, fontWeight: 500, marginBottom: 16 }}>{error}</div>}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
        <Input label="Ism" value={form.first_name} onChange={v => set('first_name', v)} placeholder="Ism" required />
        <Input label="Familiya" value={form.last_name} onChange={v => set('last_name', v)} placeholder="Familiya" required />
      </div>

      <Input label="MFY nomi" value={form.mfy_nomi} onChange={v => set('mfy_nomi', v)} placeholder="Masalan: Navoiy MFY" required />

      <Input label="Login" value={form.username} onChange={v => set('username', v)} placeholder="login_nomi" required disabled={isEdit} />

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
        <Input label={isEdit ? "Yangi parol (ixtiyoriy)" : "Parol"} value={form.password} onChange={v => set('password', v)} type="password" placeholder="••••••••" required={!isEdit} />
        <Input label="Parol tasdig'i" value={form.password_confirm} onChange={v => set('password_confirm', v)} type="password" placeholder="••••••••" required={!isEdit} />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
        <PhoneInput label="Telefon" value={form.phone} onChange={v => set('phone', v)} />
        <Input label="Lavozim" value={form.lavozim} onChange={v => set('lavozim', v)} placeholder="Masalan: Rais" />
      </div>

      <div style={{ display: 'flex', gap: 12, marginTop: 8, justifyContent: 'flex-end' }}>
        <Button variant="ghost" onClick={onClose}>Bekor qilish</Button>
        <Button onClick={handleSave} icon={isEdit ? 'check' : 'plus'}>{isEdit ? "Saqlash" : "Yaratish"}</Button>
      </div>
    </div>
  );
}
